// TODO: move these to redux actions because `window.registerLoyaltyEvent`
// changes app state

export function track(event, ...data) {
  if (typeof window === 'undefined') return;
  //console.log(event, ...data); // eslint-disable-line no-console
  setTimeout(() => {
    window.analytics.track(event, ...data);
    window.Attribution.track(event, ...data);
    if (typeof window.registerLoyaltyEvent === 'function') {
      window.registerLoyaltyEvent(event);
    }
  }, 1);
}

export function trackNow(event, ...data) {
  if (typeof window === 'undefined') return;
  //console.log(event, ...data); // eslint-disable-line no-console
  window.analytics.track(event, ...data);
  window.Attribution.track(event, ...data);
  if (typeof window.registerLoyaltyEvent === 'function') {
    window.registerLoyaltyEvent(event);
  }
}

export function trackPage() {
  if (typeof window === 'undefined') return;
  window.analytics.page(...arguments);
}

export function trackAttribution(event, ...data) {
  if (typeof window === 'undefined') return;
  window.Attribution.track(event, ...data);
}
